import React, { useState } from 'react';
import { palette } from './ui';
import { WORK_CATEGORIES } from './constants';

export default function CategoryPicker({ isDarkMode, onPick }) {
  const c = palette(isDarkMode);
  const [saving, setSaving] = useState(null);

  const pick = async (value) => {
    setSaving(value);
    await onPick(value);
    setSaving(null);
  };

  return (
    <div className="max-w-2xl mx-auto py-6 px-4">
      <h1 className={`text-2xl font-bold font-display text-center ${c.text}`}>What kind of work are you looking for?</h1>
      <p className={`text-center mt-2 text-sm ${c.secondaryText}`}>
        This helps us build the right profile for you. You can change it anytime.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
        {WORK_CATEGORIES.map(cat => (
          <button
            key={cat.value}
            onClick={() => pick(cat.value)}
            disabled={!!saving}
            className={`group rounded-2xl border p-6 text-left shadow-glass transition-all hover:shadow-purple hover:-translate-y-1 hover:border-brand-purple/40 disabled:opacity-60 ${c.card}`}
          >
            <h2 className={`text-lg font-bold font-display group-hover:text-brand-purple transition-colors ${c.text}`}>
              {saving === cat.value ? 'Setting up…' : cat.label}
            </h2>
            <p className={`text-sm mt-1 ${c.secondaryText}`}>{cat.description}</p>
            <div className="flex flex-wrap gap-2 mt-4">
              {cat.examples.map(e => (
                <span key={e} className={`px-2.5 py-1 rounded-full text-xs ${c.chip}`}>{e}</span>
              ))}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
